import _ from 'lodash';
import 'simplebar';
import 'simplebar/dist/simplebar.min.css';
import { Common } from './common';
import { Home } from './features/home';
import { YtModal } from './components/YtModal';
import { PhotobookSlider } from './components/photobookSlider';
import { Fadein } from './components/Fadein';
(function () {
  window.addEventListener('DOMContentLoaded', () => {
    Common.init();
    Home.init();
    YtModal.init();
    PhotobookSlider.init();
    Fadein.scroll();
  });

  const handleResize = _.debounce(() => {
    Common.resize();
  });
  window.addEventListener('resize', handleResize);
  const handleScroll = _.debounce(() => {
    Common.scroll();
    Fadein.scroll();
  });
  window.addEventListener('scroll', handleScroll);

  window.addEventListener('breakPoint', () => {
    Common.breakPoint();
  });
})();
